import { render, staticRenderFns } from "./IconCross.vue?vue&type=template&id=309a1072&scoped=true&"
import script from "./IconCross.vue?vue&type=script&lang=js&"
export * from "./IconCross.vue?vue&type=script&lang=js&"
import style0 from "./IconCross.vue?vue&type=style&index=0&id=309a1072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309a1072",
  null
  
)

export default component.exports